<!-- desktop nav - from medium screen 720px above -->
<template>
  <header>
    <div class="wrapper">
      <div class="p-top relative">
        <div class="g align-apart align-v-center">
          <div class="g__col">
            <masthead-brand />
          </div>
        </div>
        <nav class="m-masthead__nav">
          <ul class="m-masthead__nav-list list--inline">
            <li v-for="(auxItem, idx) in navData.AuxillaryItems" :key="auxItem.Url">
              <a :class="{
                'm-masthead__nav-item--has-divider': hasDivider(idx),
              }" class="m-masthead__nav-item" :href="auxItem.Url">
                <span :class="{
                  'm-masthead__nav-item__divider': hasDivider(idx),
                }" v-html="auxItem.Title" />
              </a>
            </li>
            <li>
              <button ref="searchButton" :aria-expanded="isSearchExpanded ? 'true' : 'false'" :id="id('search')"
                class="m-masthead__nav-item" type="button" @click="toggleSearch" @focus="
                  bindTabKey({
                    condition: 'isSearchExpanded',
                    from: 'searchButton',
                  })
                  " @blur="unbindTabKey">
                <span class="sr-only"> {{ isSearchExpanded ? `Hide` : `Expand` }} </span>
                <span class="mg-right--half">Search</span>
                <icon :name="isSearchExpanded ? `close` : `search`" title="Search" />
              </button>
            </li>
          </ul>
        </nav>
        <nav class="container mg-top masthead-nav-with-images" aria-label="Primary nav" data-masthead-nav-with-images>
          <div class="masthead-nav-wrapper">
            <ul class="masthead-nav-with-images-links" @mouseenter="toggleBlur(true)" @mouseleave="toggleBlur(false)">
              <li v-for="(item, index) in navData.PrimaryItems" :key="item.Url"
                class="masthead-nav-with-images-links__item" @pointerover="showMenu(index)" @pointerleave="hideMenu"
                @focusin="menuOpen = index" @focusout="onFocusOut">
                <a tabindex="0" :href="item.Url" :aria-labelledby="item.Title"
                  class="masthead-nav-with-images-links__item-heading" @keydown.esc="hideMenu" @touchstart="touchBegin($event, index)">
                  {{ item.Title }}
                  <svg class="chevron-label white-arrow" width="30" height="30" viewBox="0 0 16 11" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.84959 0L0 2.84959L7.97884 10.8284L10.8284 7.97884L2.84959 0Z" fill="white" />
                    <path d="M5.12915 8L7.97874 10.8496L15.9576 2.87074L13.108 0.0211549L5.12915 8Z" fill="white" />
                  </svg>
                  <svg class="chevron-label regular-arrow" width="30" height="30" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.84959 6.3999L4 9.24949L11.9788 17.2283L14.8284 14.3787L6.84959 6.3999Z"
                      fill="#333333" />
                    <path d="M9.12915 14.3999L11.9787 17.2495L19.9576 9.27064L17.108 6.42106L9.12915 14.3999Z"
                      fill="#333333" />
                  </svg>
                </a>
                <!-- dropdown menu -->

                <div v-if="menuOpen === index" class="dropdown-menu" @pointerenter="showMenu(index)"
                  @pointerleave="hideMenu">
                  <ul class="dropdown-menu-item menu-position">
                    <li class="column">
                      <div class="dropdown-menu-item__img-block">
                        <a :href="item.FirstFeaturedItem[0].Url">
                          <img :src="item.FirstFeaturedItem[0].Image.src" height="305" width="240"
                            :alt="item.FirstFeaturedItem[0].Image.alt" />
                          <div>{{ item.FirstFeaturedItem[0].Title }}</div>
                        </a>
                      </div>
                    </li>
                    <li class="column">
                      <div class="dropdown-menu-item__img-block">
                        <a :href="item.SecondFeaturedItem[0].Url">
                          <img :src="item.SecondFeaturedItem[0].Image.src" height="305" width="240"
                            :alt="item.SecondFeaturedItem[0].Image.alt" />
                          <div>{{ item.SecondFeaturedItem[0].Title }}</div>
                        </a>
                      </div>
                    </li>
                    <div class="column dropdown-menu-item__list">
                      <li v-for="menuItem in item.NonFeaturedItems" :key="menuItem.Url">
                        <a :href="menuItem.Url">{{ menuItem.Title }}</a>
                      </li>
                    </div>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>

    <portal selector="#mobile-masthead-nav-search" aria-live="polite">
      <div class="shu-design-system-v1-0">
        <masthead-search v-if="isSearchExpanded" :id="id('search')" @hide="handleSearchClose" />
      </div>
    </portal>
  </header>

</template>
<script>
// import InLineSvg from "vue-inline-svg";
import MastheadBrand from "@/components/molecules/masthead/vue-components/shared/MastheadBrand";
import { Portal } from "@linusborg/vue-simple-portal";
import Icon from "@/components/atoms/icon/Icon";
import getUuid from "@/js/lib/uuid";
// import { example } from "./data/exampledata";
import MastheadSearch from "./MastheadSearch";
import store from "../store";

const uuid = getUuid();

export default {
  components: {
    Icon,
    Portal,
    MastheadBrand,
    MastheadSearch
  },
  data() {
    return {
      menuOpen: null,
      currentTimer: null,
      navData: store.state.navData,
      isSearchExpanded: store.state.isSearchExpanded,
      previousTarget: "",
      isTouchDevice: false,
    };
  },
  mounted() {
    this.isTouchDevice = window.matchMedia("(any-pointer: coarse)").matches;
  },
  onBeforeUnmount() {
    document.removeEventListener('touchstart', this.handleGlobalTouch);
  },
  methods: {
    // passing in index of the menu item so it will show the correct menu items only
    showMenu(index) {
      if(this.isTouchDevice) return;
      this.menuOpen = index;
    },
    hideMenu() {
      if(this.isTouchDevice) return;
      this.menuOpen = null;
    },
    touchBegin(event, index) {
      if(this.menuOpen === index) {
        return;
      }
  
      if(event.cancelable) {
        event.preventDefault();
      }

      if(this.previousTarget) {
        this.previousTarget.classList.remove('tabletActive');
      }

      event.currentTarget.classList.add('tabletActive');

      this.menuOpen = this.menuOpen === index ? null : index;

      this.previousTarget = event.currentTarget;
      document.addEventListener('touchstart', this.handleGlobalTouch, { passive: true });
    },
    handleGlobalTouch(event) {
      if(!this.previousTarget) return;
      
      const dropdownParent = this.previousTarget.closest(".masthead-nav-with-images");
      const mainContainer = dropdownParent || this.previousTarget;
      const clickedInside = mainContainer.contains(event.target);

      if(!clickedInside){
        // User must've touched somewhere else on the screen, close menu
        this.menuOpen = null;
        this.previousTarget.classList.remove('tabletActive');
        this.previousTarget = null;
        document.removeEventListener('touchstart', this.handleGlobalTouch);
      }
    },
    isInsideNav(el) {
      return this.$refs.nav.contains(el);
    },
    onFocusOut() {
      requestAnimationFrame(() => {
        const active = document.activeElement;

        // If focus is still somewhere inside any nav item, do nothing
        const stillInside = this.$el.contains(active);

        if (!stillInside) {
          this.hideMenu();
        }
      });
    },
    bindTabKey({ from }) {
      Mousetrap.bind("tab", (nativeEvent) => {
        offerFocus({ from, nativeEvent });
      });
    },
    unbindTabKey() {
      Mousetrap.unbind("tab");
    },
    toggleSearch() {
      this.isSearchExpanded = !this.isSearchExpanded;
    },
    hasDivider: (idx) => idx > 0,
    id(prefix = "item") {
      return `masthead-${prefix}-${uuid}`;
    },
    handleSearchClose() {
      this.toggleSearch();
      this.$refs.searchButton.focus();
    },
    toggleBlur(shouldBlur) {
      const existingStyle = document.getElementById('dynamic-blur-effect');

      if (shouldBlur) {
        if (existingStyle) return;

        const styleTag = document.createElement('style');
        styleTag.id = 'dynamic-blur-effect';

        styleTag.textContent = `
          #content, .shu-legacy {
            animation: blur_in 0.3s ease-out forwards !important;
            backface-visibility: hidden;
            perspective: 1000px;
            will-change: filter;  
            clip-path: inset(0px);
          }
          @keyframes blur_in {
            0% { filter: blur(0px); }
            100% { filter: blur(5px); }
          }
          @keyframes blur_out {
            0% { filter: blur(5px); }
            100% { filter: blur(0px); }
          }
        `;

        document.head.appendChild(styleTag);
      } else if (existingStyle) {

        if (document.getElementById("content")) {
          document.getElementById("content").style.setProperty('animation', 'blur_out 0.6s ease-out forwards', 'important');
        }
        if (document.getElementsByClassName("shu-legacy")[0]) {
          document.getElementsByClassName("shu-legacy")[0].style.setProperty('animation', 'blur_out 0.6s ease-out forwards', 'important');
        }

        // Wait 300ms (0.3s, this is length of animation) for the fade out to finish then delete the tag
        setTimeout(() => {
          existingStyle.remove();
          if (document.getElementById("content")) {
            document.getElementById("content").style.removeProperty('animation');
          }
          if (document.getElementsByClassName("shu-legacy")[0]) {
            document.getElementsByClassName("shu-legacy")[0].style.removeProperty('animation');
          }
        }, 300);
      }
    }
  },
};
</script>